export const TOKEN = document.getElementById('root')?.getAttribute('token');
export const TYPE = document.getElementById('root')?.getAttribute('type');
export const STUDENT_ID = document.getElementById('root')?.getAttribute('studentid');
export const DRILL_TITLE = document.getElementById('root')?.getAttribute('drilltitle');
export const FILE_LINK = document.getElementById('root')?.getAttribute('filelink');
export const FILE_LINK_LABEL = document.getElementById('root')?.getAttribute('filelinklabel');
export const MB_TITLE = document.getElementById('root')?.getAttribute('mbtitle');

export const VIDEO_URL = document.getElementById('root')?.getAttribute('videourl');
export const VIDEO_BUTTON_LABEL = document.getElementById('root')?.getAttribute('videobuttonlable');
export const MASTERY_CARD_LABEL = document.getElementById('root')?.getAttribute('masterycardlabel');
export const MASTERY_CARD_POPUP_LABEL = document.getElementById('root')?.getAttribute('masterycardpopuplabel');
export const COMPONENT = document.getElementById('root')?.getAttribute('component') || 'mastery';
export const DISABLED_BUTTON = document.getElementById('root')?.getAttribute('disabledButton');

export const MAX_MASTERY_COUNT = 5;
